(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('copyToClipboard', copyToClipboard);

    function copyToClipboard(AlertService) {
        var directive = {
            restrict: 'A',
            require: ['?ngModel'],
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ctrls) {
            element.click(function () {
                var value = undefined;
                if (ctrls && ctrls.length > 0 && ctrls[0]) {
                    var ngModelCtrl = ctrls[0];
                    value = ngModelCtrl.$viewValue;
                } else {
                    value = attrs.copyToClipboard;
                }
                var
                    body = angular.element(window.document.body),
                    textarea = angular.element('<textarea/>');
                    textarea.css({ position: 'fixed', opacity: '0' });
                if(value.indexOf('path+') > -1 ) {
                    textarea.val(window.location.origin + window.location.pathname + value.substring(5));
                } else {
                    textarea.val(value);
                }
                body.append(textarea);
                textarea[0].select();
                document.execCommand('copy');
                textarea.remove();
                AlertService.success("Link copied");
                if(!scope.$$phase) {
                    scope.$apply();
                }
            });
        }

    }
})();
